// @mui material components
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
// Dreamer Admin Panel Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
// Dreamer Admin Panel Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
// Dreamer Admin Panel Dashboard React base styles
import typography from "assets/theme/base/typography";
// Dashboard layout components
import BuildByDevelopers from "layouts/dashboard/components/BuildByDevelopers";
import WorkWithTheRockets from "layouts/dashboard/components/WorkWithTheRockets";
import Projects from "layouts/dashboard/components/Projects";
import OrderOverview from "layouts/dashboard/components/OrderOverview";
// Data
// import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import gradientLineChartData from "layouts/dashboard/data/gradientLineChartData";
import { useNavigate } from "react-router-dom";
import { GraphModel } from "model/graphDataModel";
import { GraphDataList } from "model/graphDataModel";
import api from "api/api";
import { ApiResponse } from "model/apiResponseModel";
import { CircularProgress } from "@mui/material";
import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";
import { ProjectModel } from "model/projectListModel";
import { convertSecondsToHoursLive } from "helpers/logMessages";
import Table from "examples/Tables/Table";

function Dashboard() {
  const { size } = typography;
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const [labels, setLables] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalProjects, setTotalProjects] = useState(0);
  const [totalCompletedProjects, setTotalCompletedProjects] = useState(0);
  const [totalNotStartedProjects, setTotalNotStartedProjects] = useState(0);
  const [totalOnGoingProjects, setTotalOnGoingProjects] = useState(0);
  const [projectsData, setProjectsData] = useState([]);
  const [userData, setUserData] = useState([]);

  const reportsBarChartData = {
    chart: {
      labels: labels,
      datasets: { label: "Projects", data: projectsData },
    },
    items: [
      {
        icon: { color: "primary", component: "library_books" },
        label: "Total Projects",
        progress: { content: totalProjects },
      },
      {
        icon: { color: "info", component: "touch_app" },
        label: "Completed Projects",
        progress: { content: totalCompletedProjects },
      },
      // {
      //   icon: { color: "warning", component: "payment" },
      //   label: "On Going Projects",
      //   progress: { content: totalOnGoingProjects },
      // },
      // {
      //   icon: { color: "error", component: "extension" },
      //   label: "Not Started Projects",
      //   progress: { content: totalNotStartedProjects },
      // },
    ],
  };
  const gradientLineChartData = {
    labels: labels,
    datasets: [
      // {
      //   label: "Projects",
      //   color: "info",
      //   data: projectsData,
      // },
      {
        label: "Users",
        color: "dark",
        data: userData,
      },
    ],
  };

  const { chart, items } = reportsBarChartData;
  const navigate = useNavigate();

  useEffect(() => {
    const loginData = JSON.parse(
      localStorage.getItem("loginData") || sessionStorage.getItem("loginData")
    );
    if (!loginData) {
      navigate("/authentication/sign-in");
    } else {
      fetchGraphData();
      fetchProjects(1, "");
    }
  }, []);

  const fetchGraphData = async () => {
    try {
      setIsLoading(true);
      const response = await api.getGraphDetail();
      const apiResponse = new ApiResponse(response.status, response.message);

      if (apiResponse.status === 1) {
        const newLabels = [];
        const newProjectsData = [];
        const newUsersData = [];
        const graphModelData = new GraphModel(response.data);
        if (graphModelData.projectsByMonth.length > 0) {
          const graphList = graphModelData.projectsByMonth;
          for (let i = 0; i < graphList.length; i++) {
            const graphSingleModel = new GraphDataList(graphList[i]);
            newLabels.push(graphSingleModel.label);
            newProjectsData.push(graphSingleModel.value);
            newUsersData.push(graphSingleModel.users_per_month);
          }
          setProjectsData(newProjectsData);
          setLables(newLabels);
          setUserData(newUsersData);
          setTotalProjects(graphModelData.totalProjectCount);
          setTotalUsers(graphModelData.totalUsers);
          setTotalCompletedProjects(graphModelData.completedProjectCount);
          setTotalNotStartedProjects(graphModelData.notStartedProjectCount);
          setTotalOnGoingProjects(graphModelData.onGoingProjectCount);
        }
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProjects = async (page = 1, search = "") => {
    try {
      setIsLoading(true);
      let postData = {
        limit,
        page,
      };

      if (search && search.trim() !== "") {
        postData.search = search.trim();
      }

      const response = await api.getProjectsList(postData);
      const apiResponse = new ApiResponse(response.status, response.message);
      if (apiResponse.status === 1) {
        const projectModelData = new ProjectModel(response.data);
        //  console.log(projectModelData);
        setColumns([
          { name: "project", align: "left" },
          { name: "design", align: "center" },
          { name: "artist", align: "center" },
          { name: "brand", align: "center" },
          { name: "logged Time", align: "center" },
          { name: "created", align: "center" },
          { name: "status", align: "center" },
        ]);
        setRows(
          projectModelData.projects.map((project) => ({
            linkPath: `/project-detail?projectId=${project._id}`,
            project: (
              <SoftBox display="flex" alignItems="center" px={1} pb={0.5}>
                <SoftAvatar
                  src={project.image[0] || userImage}
                  alt={project.name}
                  size="sm"
                  variant="rounded"
                />
                <SoftBox display="flex" flexDirection="column" ml={2}>
                  <SoftTypography variant="button" fontWeight="medium">
                    {project.name}
                  </SoftTypography>
                  <SoftTypography variant="caption" color="secondary">
                    {project.email}
                  </SoftTypography>
                </SoftBox>
              </SoftBox>
            ),
            design: (
              <SoftTypography
                variant="caption"
                color="secondary"
                fontWeight="medium"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  minHeight: "40px",
                }}
              >
                {project.design}
              </SoftTypography>
            ),
            artist: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {project.artist}
              </SoftTypography>
            ),
            brand: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {project.brand}
              </SoftTypography>
            ),
            "logged Time": (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {convertSecondsToHoursLive(project.totalDuration)}
              </SoftTypography>
            ),
            created: (
              <SoftTypography variant="caption" color="secondary" fontWeight="medium">
                {new Date(project.created_at * 1000).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                })}
              </SoftTypography>
            ),
            status: (
              <SoftBadge
                variant="gradient"
                badgeContent={
                  project.project_status === "not_started"
                    ? "Not Started"
                    : project.project_status === "ongoing"
                    ? "Ongoing"
                    : "Completed"
                }
                color={
                  project.project_status === "not_started"
                    ? "error"
                    : project.project_status === "ongoing"
                    ? "warning"
                    : "success"
                }
                size="xs"
              />
            ),
          }))
        );
        setTotalPages(response.totalPages);
      } else {
        alert(apiResponse.message);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading ? (
        <SoftBox display="flex" justifyContent="center" alignItems="center" height="100vh">
          <CircularProgress />
        </SoftBox>
      ) : (
        <>
          <SoftBox py={3}>
            <SoftBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={2.5} xl={2.3}>
                  <MiniStatisticsCard
                    title={{ text: "Total Users" }}
                    count={totalUsers}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "person" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2.5} xl={2.3}>
                  <MiniStatisticsCard
                    title={{ text: "Total Projects" }}
                    count={totalProjects}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "summarize" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2.5} xl={2.3}>
                  <MiniStatisticsCard
                    title={{ text: "Completed" }}
                    count={totalCompletedProjects}
                    percentage={{ color: "success", text: "" }}
                    icon={{ color: "info", component: "check_circle" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2.5} xl={2.3}>
                  <MiniStatisticsCard
                    title={{ text: "on going" }}
                    count={totalOnGoingProjects}
                    percentage={{ color: "error", text: "" }}
                    icon={{ color: "info", component: "autorenew" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={2.5} xl={2.3}>
                  <MiniStatisticsCard
                    title={{ text: "not started" }}
                    count={totalNotStartedProjects}
                    percentage={{ color: "success", text: "" }}
                    icon={{
                      color: "info",
                      component: "hourglass_empty",
                    }}
                  />
                </Grid>
              </Grid>
            </SoftBox>
            <SoftBox mb={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} lg={5}>
                  <ReportsBarChart
                    title="Overview"
                    description={<>{/* (<strong>+23%</strong>) than last week */}</>}
                    chart={chart}
                    items={items}
                  />
                </Grid>
                <Grid item xs={12} lg={7}>
                  <GradientLineChart
                    title="Users Overview"
                    description={
                      <SoftBox display="flex" alignItems="center">
                        {/* <SoftTypography variant="button" color="text" fontWeight="medium">
                        4% more{" "}
                        <SoftTypography variant="button" color="text" fontWeight="regular">
                          in 2024
                        </SoftTypography>
                      </SoftTypography> */}
                      </SoftBox>
                    }
                    height="20.25rem"
                    chart={gradientLineChartData}
                  />
                </Grid>
              </Grid>
            </SoftBox>
            {rows.length > 0 && <Table columns={columns} rows={rows} />}
          </SoftBox>
        </>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
